export default __webpack_public_path__ + "xamarin.4cacba1e.png";